module.exports = __webpack_public_path__ + "static/media/engine-small.03ae35fc.jpg";